"use client";
import { useEffect } from "react";

import setSearchId from "helpers/google-tag-manager/set-search-id";
import { initialLoadGtmEvent } from "helpers/google-tag-manager/events/initialLoadEvents";

const InitialPageLoadGtmEvent = ({ pageNameForSearchId, pageType }) => {
  useEffect(() => {
    setSearchId(pageNameForSearchId).then((result) => {
      initialLoadGtmEvent({ search_id: result, pageType });
    });
  }, []);
};

export default InitialPageLoadGtmEvent;
